import { NEWSBOARD_POST_PROFILE_TAB_COMMENTS } from './NewsboardPostProfileTabs.constants'

export function getIsNewsboardPostProfileTabComments(activeTab) {
  return activeTab === NEWSBOARD_POST_PROFILE_TAB_COMMENTS
}
